export const charityConfig = {
  name: '',
  logoUrl: '',
  tagline: '',
  mission: '',
  impactStatement: '',
  website: '#',
  accentColor: '#E31837',
  secondaryColor: '#00558C',
};

export const getCharityThemeColors = (gameType) => {
  const themes = {
    classic5050: {
      primary: 'from-blue-600 to-cyan-500',
      secondary: 'from-blue-100 to-cyan-100',
      darkSecondary: 'from-blue-900/30 to-cyan-900/30',
      accent: 'text-amber-500',
      border: 'border-blue-300 dark:border-blue-700',
    },
    progressive5050: {
      primary: 'from-purple-600 to-pink-500',
      secondary: 'from-purple-100 to-pink-100',
      darkSecondary: 'from-purple-900/30 to-pink-900/30',
      accent: 'text-yellow-400',
      border: 'border-purple-300 dark:border-purple-700',
    },
    chaseTheAce: {
      primary: 'from-red-600 to-rose-500',
      secondary: 'from-red-100 to-rose-100',
      darkSecondary: 'from-red-900/30 to-rose-900/30',
      accent: 'text-red-500',
      border: 'border-red-300 dark:border-red-700',
    },
    prizeDraw: {
      primary: 'from-violet-600 to-fuchsia-500',
      secondary: 'from-violet-100 to-fuchsia-100',
      darkSecondary: 'from-violet-900/30 to-fuchsia-900/30',
      accent: 'text-violet-500',
      border: 'border-violet-300 dark:border-violet-700',
    },
    eliminationDraw: {
      primary: 'from-blue-600 to-purple-500',
      secondary: 'from-blue-100 to-purple-100',
      darkSecondary: 'from-blue-900/30 to-purple-900/30',
      accent: 'text-pink-500',
      border: 'border-blue-300 dark:border-blue-700',
    },
    squareGame: {
      primary: 'from-emerald-600 to-green-500',
      secondary: 'from-emerald-100 to-green-100',
      darkSecondary: 'from-emerald-900/30 to-green-900/30',
      accent: 'text-emerald-500',
      border: 'border-emerald-300 dark:border-emerald-700',
    },
  };
  return themes[gameType] || themes.classic5050;
};
